import axios from 'axios';
import { apiCaller, checkStatusResponse, notifyToast } from '../helpers';

const initialState = {
	loading : false,
	isLogin : false
};

export default function(state = initialState, action) {
	switch (action.type) {
		case 'SET_STATE_ADMIN':
			return Object.assign({}, state, {
				[action.propertyName]: action.value
			});
		case 'SET_MULTIPLE_STATE_ADMIN':
			return Object.assign({}, state, action.newObject);
		default:
			return state;
	}
}

// set state dashboard
export function setStateAdmin(propertyName, value) {
	return {
		type         : 'SET_STATE_ADMIN',
		propertyName,
		value
	};
}

// set multi dashboard
export function setMultipleStateAdmin(newObject) {
	return {
		type      : 'SET_MULTIPLE_STATE_ADMIN',
		newObject
	};
}

export function onLogin(body) {
	const header = {
		'Content-Type' : 'application/json'
	};

	return async (dispatch) => {
		try {
			dispatch(setStateAdmin('loading', true));
			const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/authentication/token`, body, header);
			console.log(res);
			dispatch(setStateAdmin('loading', false));
			notifyToast('success', res.data.message);
			localStorage.setItem('_token', res.data.response.token);
			localStorage.setItem('_adminInfo', JSON.stringify(res.data.response));
			setTimeout(() => {
				dispatch(setStateAdmin('isLogin', true));
			}, 1500);
		} catch (error) {
			dispatch(setStateAdmin('loading', false));
			console.log(error.response);
			checkStatusResponse(error.response);
		}
	};
}

export function onLogout(body) {
	const header = {
		'Content-Type' : 'application/json'
	};
	return async (dispatch) => {
		try {
			dispatch(setStateAdmin('loading', true));
			await axios.post(`${process.env.REACT_APP_API_URL}/api/authentication/revoke-token`, body, header);
			dispatch(setStateAdmin('loading', false));
			setTimeout(() => {
				dispatch(setStateAdmin('isLogin', false));
			}, 300);
			localStorage.clear();
		} catch (error) {
			dispatch(setStateAdmin('loading', false));
			// console.log(error.response);
			checkStatusResponse(error.response);
			setTimeout(() => {
				dispatch(setStateAdmin('isLogin', false));
			}, 1500);
			localStorage.clear();
		}
	};
}

export function refreshToken(body) {
	const header = {
		'Content-Type' : 'application/json'
	};
	return async (dispatch) => {
		try {
			dispatch(setStateAdmin('loading', true));
			const res = await axios.post(
				`${process.env.REACT_APP_API_URL}/api/authentication/refresh-token`,
				body,
				header
			);
			console.log(res);
			dispatch(setStateAdmin('loading', false));
		} catch (error) {
			dispatch(setStateAdmin('loading', false));
			console.log(error.response);
			checkStatusResponse(error.response);
		}
	};
}
